import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { markRaw, nextTick, ref } from "vue";
  import Popup from "@/components/_partials/Popup.vue";
  import { ErrorPopup } from "@/components/_partials/lot-info-popup";
  import { trans } from "@/utils/trans";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorPopupWrapper',
  setup(__props, { expose: __expose }) {

  const errorPopupComponent = markRaw(ErrorPopup);
  const errorPopup = ref<typeof Popup>(null);

  const defaultTitle = trans("modals.error_popup.title");
  const title = ref<string>(defaultTitle);

  const openPopup = (errors = []) => {
    title.value = defaultTitle;
    const errorValues = Object.values(errors);
    for (const errorArray of errorValues) {
      if (errorArray.length) {
        title.value = errorArray[0]?.title || defaultTitle;
        break;
      }
    }

    nextTick(() => {
      errorPopup.value.toggleComponent(errorPopupComponent, { errors });
      errorPopup.value.open();
    });
  };

  __expose({
    openPopup
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    title: title.value,
    class: "approved-error-popup",
    ref_key: "errorPopup",
    ref: errorPopup
  }, null, 8, ["title"]))
}
}

})